import React from "react";
import { HiChevronRight } from "react-icons/hi";
import { Link } from "react-router-dom";
import CitySetting from "../../components/feesetting/CitySetting";
import StateSetting from "../../components/feesetting/StateSetting";
import InterStateSetting from "../../components/feesetting/InterStateSetting";
import InterCountrySetting from "../../components/feesetting/InterCountrySetting";
import ShoppingFeeSet from "../../components/feesetting/ShoppingFeeSet";

const ShoppingFeeSetting = () => {
  return (
    <div className="p-4">
      <div className="flex justify-between">
        <div className="flex flex-col">
          <h1 className="w-full h-auto text-2xl mb-2 text-[#333843] font-medium">
            Shopping Fee Calculation
          </h1>

          <div className="flex mb-4 justify-start items-center gap-2 mt-4">
            <Link to="/dashboard">
              <p className="text-[14px] text-[#1F7BF4] font-medium hover:underline">
                Dashboard
              </p>
            </Link>

            <HiChevronRight className=" text-gray-500" />

            <p className="text-[14px] text-[#1F7BF4]  font-medium">
              Fee Setting
            </p>

            <HiChevronRight className=" text-gray-500" />

            <p className="text-[14px] text-[#667085] font-medium">
              Shopping Fee Calculation
            </p>
          </div>
        </div>

        <div className="flex items-center gap-4"></div>
      </div>

      <div className="bg-white rounded-lg w-full p-4 h-auto shadow-md">
        <div className="bg-white rounded-lg w-full p-4 h-auto shadow-md">
          <div className="relative overflow-x-auto">
            <div className="mt-4">
              <div className=" bg-gray-50 text-center">
                <p className="text-lg font-bold">SHOPPING FEE CALCULATION</p>
              </div>
              <ShoppingFeeSet />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white mt-4 rounded-lg w-full p-4 h-auto shadow-md">
        <div className=" bg-gray-50 m-4 text-center">
          <p className="text-lg font-bold">
            DELIVERY FEE CALCULATION AND SHARING FORMULAE
          </p>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full overflow-x-auto text-sm text-left text-gray-500">
            <thead className="w-full text-base font-bold whitespace-nowrap text-gray-700 bg-gray-100">
              <tr>
                <th className="px-4 py-3 text-center border-2">In City</th>
                <th className="px-4 py-3 text-center border-2">In State</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-4 py-3 text-center border-2">
                  <CitySetting />
                </td>
                <td className="px-4 py-3 text-center border-2">
                  <StateSetting />
                </td>
              </tr>
            </tbody>
          </table>
          <div className="relative mt-4 overflow-x-auto">
            <table className="w-full overflow-x-auto text-sm text-left text-gray-500">
              <thead className="w-full text-base font-bold whitespace-nowrap text-gray-700 bg-gray-100">
                <tr>
                  <th className="px-4 py-3 text-center border-2">
                    Inter State
                  </th>
                  <th className="px-4 py-3 text-center border-2">
                    Inter Country
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-4 py-3 text-center border-2">
                    <InterStateSetting />
                  </td>
                  <td className="px-4 py-3 text-center border-2">
                    <InterCountrySetting />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShoppingFeeSetting;
